/**
 * Состав пака «editorial-serif» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 6 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 4 из 6 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.67 },
    // 2 из 6 воронок: palette → ближайшая тема по цветам
    { themeId: 'bento-brutalist', weight: 0.33 },
  ],
  fonts: [
    // 6 из 6 воронок: fontId
    { fontId: 'lora', weight: 1.0 },
  ],
  screenKinds: [
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.274
    { kind: 'I1', share: 0.28 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.250; сюда свёрнуты Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.26 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.167
    { kind: 'Q4', share: 0.17 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.095
    { kind: 'Q1', share: 0.1 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.095
    { kind: 'N8', share: 0.1 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.083
    { kind: 'N4', share: 0.09 },
  ],
  blocks: [
    // в 4 из 6 воронок (признаки.json blocks), подъём 0.97; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 10 из 11, optionIndicator 11 из 11
    {
      type: 'single_choice',
      weight: 0.67,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 1 из 6 воронок (признаки.json blocks), подъём 0.37; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 1 из 1, optionIndicatorStyle 1 из 1, optionIndicatorPosition 1 из 1
    {
      type: 'multiple_choice',
      weight: 0.17,
      settings: {
        optionIndicator: 'auto',
        optionIndicatorStyle: 'native',
        optionIndicatorPosition: 'left',
      },
    },
    // в 2 из 6 воронок (признаки.json blocks), подъём 2.05
    { type: 'name_field', weight: 0.33, settings: {} },
  ],
  niches: [
    // 1 из 6 воронок (признаки.json theme)
    { niche: 'relationships', weight: 0.17 },
    // 1 из 6 воронок (признаки.json theme)
    { niche: 'language_learning', weight: 0.17 },
  ],
};
